import { render, staticRenderFns } from "./IntelliMatIntroduce.vue?vue&type=template&id=607ad4bd&scoped=true&"
import script from "./IntelliMatIntroduce.vue?vue&type=script&lang=js&"
export * from "./IntelliMatIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./IntelliMatIntroduce.vue?vue&type=style&index=0&id=607ad4bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ad4bd",
  null
  
)

export default component.exports